import React from 'react';

export const CheckIcon = ({ stroke }: { stroke?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4667 4.03906L6.13338 11.3724L2.80005 8.03906"
      stroke={stroke || '#0F2E2F'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
